import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, ButtonProps } from '@swyftx/aviary/atoms/Button';
import { EnhancedTooltip } from '@swyftx/aviary/molecules/EnhancedTooltip/EnhancedTooltip';

import { MarginAccountTransferModal } from '@routes/SwyftxMargin/components/Account';

import { observer } from 'mobx-react-lite';
import { useSwyftxMargin } from 'src/lib/margin';
import { useMarginAccount } from 'src/lib/margin/hooks/account';

type Props = Pick<ButtonProps, 'variant' | 'size' | 'className'>;

const SwyftxMarginAppHeaderTransfer: React.FC<Props> = observer(({ variant = 'filled', size = 'md', className }) => {
  const { isUnderMaintenance } = useSwyftxMargin();
  const { isLoading } = useMarginAccount();
  const { t } = useTranslation('margin');

  return (
    <MarginAccountTransferModal>
      <span className={className}>
        <EnhancedTooltip title={isUnderMaintenance ? t('maintenance.tooltips.transfer') : undefined}>
          <Button
            variant={variant}
            color='accent'
            size={size}
            disabled={isLoading || isUnderMaintenance}
            className={className}
          >
            {t('instruments.selector.panel.transferFunds')}
          </Button>
        </EnhancedTooltip>
      </span>
    </MarginAccountTransferModal>
  );
});

export { SwyftxMarginAppHeaderTransfer };
